module.exports = __webpack_public_path__ + "assets/img/integruota-i-stoga.a93f766e.jpg";